import React, { FunctionComponent, useState } from "react";
import axios from "axios"; // Import the axios library
import MainComponent from "../components/MainComponent";
import FooterComponent from "../components/FooterComponent";
import styles from "./MacBookAir1.module.css";

interface Message {
  id: number;
  content: string;
}

const MacBookAir1: FunctionComponent = () => {
  const [userMessages, setUserMessages] = useState<Message[]>([]);
  const [gptResponse, setGptResponse] = useState<string | undefined>(undefined);
  const [topThreeDataPlans, setTopThreeDataPlans] = useState<any[]>([]); // Replace 'any' with the appropriate type

  const handleUserMessage = async (message: string) => {
    // Handle the user's message here
    console.log("User message:", message);
    // Perform any necessary actions based on the message

    // Update userMessages with the new message
    setUserMessages((prevMessages) => [
      ...prevMessages,
      { id: Date.now(), content: message },
    ]);

    // Reset gptResponse
    setGptResponse(undefined);

    try {
      // Make the second axios request and update gptResponse
      const response2 = await axios.post('/chatgpt2', {
        topThreeDataPlans,
        userMessage: message,
      });
      console.log(response2.data);

      const gptResponse = response2.data.result.response.body.choices[0].message.content;

      setGptResponse(gptResponse);
    } catch (error) {
      console.error("Error in second axios request:", error);
      // Handle the error if needed
    }
  };

  return (
    <div className={styles.macbookAir1}>
      <header className={styles.header}>
        <h1 className={styles.gpt}>요금제 GPT</h1>
        <img className={styles.headerChild} alt="" src="/line-1@2x.png" />
      </header>
      <MainComponent userMessages={userMessages} gptResponse={gptResponse} />
      <FooterComponent 
        onUserMessage={handleUserMessage} 
        setGptResponse={setGptResponse} 
        setTopThreeDataPlans={setTopThreeDataPlans} />
    </div>
  );
};

export default MacBookAir1;
